import React, { Component } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'

class SharingForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: ''
    }

    this.email = React.createRef()
  }

  componentDidMount() {
    this.email.current.focus()
  }

  render() {
    const { email } = this.state

    const buttonClassName = classnames({
      'button--primary': true,
      'button--success': email.indexOf('@') !== -1
    })

    return (
      <div className="sharing-form">
        <input ref={this.email}
          type="text"
          className="input--light"
          value={email || ''}
          placeholder="Band member's email"
          onChange={(e) => this.setState({email: e.target.value})} />

        <button className={buttonClassName} onClick={() => {
          this.props.shareRider(this.state.email)
        }}>Invite</button>
      </div>
    )
  }
}

SharingForm.propTypes = {
  shareRider: PropTypes.func
}

SharingForm.defaultProps = {
  shareRider: function() {}
}

export default SharingForm



// WEBPACK FOOTER //
// ./src/components/rider/rider-sharing/sharing-form.js